export default {"src":"/_next/static/media/bathTub.c06bedbb.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};